import React, { createContext, useContext, useState } from 'react';

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [hasSeenPopup, setHasSeenPopup] = useState(false);

  return (
    <PopupContext.Provider value={{ hasSeenPopup, setHasSeenPopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
